import type { EventReminder } from 'models';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Button, Card, Icon, Space } from 'ui';
import { EventAuthor } from './event-author';
import { EventInvitees } from './event-invitees';
import { useInviteMorePeople } from './hooks';
import { ReminderInviteesModal } from './reminder-invitees-modal';
import { SendInvitationsModal } from './send-invitations-modal';

type P = {
  event: EventReminder;
};

const ReminderDetailInvitees = ({ event }: P) => {
  const { goingCount } = event;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSendInvitationsModalOpen, setIsSendInvitationsModalOpen] = useState(false);
  const { canInviteUserToEvent } = usePermissions();
  const { t } = useTranslation();

  const handleInviteMorePeople = useInviteMorePeople({
    event,
    onInvite() {
      setIsSendInvitationsModalOpen(true);
    },
  });

  return (
    <>
      <Card
        extra={
          <Button
            onClick={() => {
              setIsModalOpen(true);
            }}
            type="link-primary"
          >
            See all
          </Button>
        }
        title={
          <Card.Title icon={<Icon icon="group-line" />}>{t('People ({{count}})', { count: goingCount })}</Card.Title>
        }
      >
        <Space block orientation="vertical" size="middle">
          <EventAuthor event={event} />
          <EventInvitees event={event} />
          {canInviteUserToEvent({ event }) ? (
            <Button block icon={<Icon icon="user-add-line" />} onClick={handleInviteMorePeople} type="secondary">
              Add more people
            </Button>
          ) : null}
        </Space>
      </Card>

      <ReminderInviteesModal
        event={event}
        isOpened={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        onOpenInviteModal={() => {
          setIsSendInvitationsModalOpen(true);
        }}
      />
      <SendInvitationsModal
        event={event}
        isOpened={isSendInvitationsModalOpen}
        onClose={() => {
          setIsSendInvitationsModalOpen(false);
        }}
      />
    </>
  );
};

export default ReminderDetailInvitees;
